import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";
import { passengerEndpoints } from "../helpers/requests/apiEndpoints";

const api = CustomAxiosInstance();

const methods = {
  createPassenger: (payload) =>
    api
      .post(passengerEndpoints.createPassengerUrl, payload)
      .then((res) => res.data),
  getCancelledPassenger: () =>
    api
      .get(passengerEndpoints.getCancelledPassengerUrl)
      .then((res) => res.data),
};

export default methods;
